<div mat-dialog-title class="popup-header">
  <div class="popup-title">{{imageLabel[currentFile.virtualConsultFileType]}}</div>
  <button class="popup-btn-close" [mat-dialog-close]="true">X</button>
</div>
<div class="area-popup">
  <img src="{{currentFile.location}}" id="pic" [ngStyle]="{'transform': 'rotate(' + rotation + 'deg)'}">
</div>
<div class="button-container">
  <button class="btn-ava" (click)="prevOfIndex()" [disabled]="curIndex == 0" id="image-left">
    <<</button> <button class="btn-ava rotate-buttons" (click)="rotate(-90)"><i class="fa fa-undo"></i>
  </button>
  <button class="btn-ava rotate-buttons" (click)="rotate(90)"><i class="fa fa-repeat"></i></button>
  <button class="btn-ava" (click)="nextOfIndex()" [disabled]="curIndex == data.files.length - 1" style="float:right;">>></button>
</div>
